<template>
	<div class="range-slider">
		<!-- <span @change="slider">from <input v-model.number="minPrice" type="number"  min="0" max="120000"/> to <input  v-model.number="maxPrice" type="number"  min="0" max="120000"/></span> -->
		<input @change="slider" v-model.number="rangeInicio" min="1" :max="length" step="1" type="range" />
		<input @change="slider" v-model.number="rangeFim" min="1" :max="length" step="1" type="range" />
		<svg width="100%" height="24">
			<line x1="4" y1="0" x2="100%" y2="0" stroke="#444" stroke-width="12" stroke-dasharray="1 28"></line>
		</svg>

		<div class="text-center">
			<h3>{{ rangeInicio }} {{ _traducao('global', 'ate') }} {{ rangeFim }}</h3>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			rangeInicio: 0,
			rangeFim: 0,
			length: 0
		}
	},

	methods: {
		slider() {
			if (this.rangeInicio > this.rangeFim) {
				var tmp = this.rangeFim
				this.rangeFim = this.rangeInicio
				this.rangeInicio = tmp
			}

			this.$emit('range', [this.rangeInicio, this.rangeFim])
		},

		carregaDados(start, end, length) {
			this.length = length
			this.rangeInicio = start
			this.rangeFim = end
		}
	}
}
</script>

<style scoped>
.range-slider {
	width: auto;
	margin: auto;
	text-align: center;
	position: relative;
	height: 6em;
}

.range-slider svg,
.range-slider input[type='range'] {
	position: absolute;
	left: 0;
	bottom: 0;
}

input[type='number'] {
	border: 1px solid #ddd;
	text-align: center;
	font-size: 1.6em;
	-moz-appearance: textfield;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

input[type='number']:invalid,
input[type='number']:out-of-range {
	border: 2px solid #ff6347;
}

input[type='range'] {
	-webkit-appearance: none;
	width: 100%;
}

input[type='range']:focus {
	outline: none;
}

input[type='range']:focus::-webkit-slider-runnable-track {
	background: #2196f3;
}

input[type='range']:focus::-ms-fill-lower {
	background: #2196f3;
}

input[type='range']:focus::-ms-fill-upper {
	background: #2196f3;
}

input[type='range']::-webkit-slider-runnable-track {
	width: 100%;
	height: 5px;
	cursor: pointer;
	animate: 0.2s;
	background: #2196f3;
	border-radius: 1px;
	box-shadow: none;
	border: 0;
}

input[type='range']::-webkit-slider-thumb {
	z-index: 2;
	position: relative;
	box-shadow: 0px 0px 0px #000;
	border: 1px solid #2196f3;
	height: 18px;
	width: 18px;
	border-radius: 25px;
	background: #a1d0ff;
	cursor: pointer;
	-webkit-appearance: none;
	margin-top: -7px;
}
</style>